<template>
  <div class="pt-2" style="background: #f0f0f0;font-family: PingFangSC-Medium, PingFang SC;height: 100%;padding: 10px;">
    <v-card flat>
      <div style="padding: 10px;">
        <el-button type="primary" v-if="_hasButtonPermission('导出')" @click="exportData" icon="el-icon-download">导出</el-button>
        <el-button type="danger" @click="back" icon="el-icon-back">返回</el-button>
      </div>
      <div style="margin-top: 15px;min-height: 500px;padding: 10px;">
        <table-merge
            :table-data="tableData"
            :table-field="tableField"
            :table-config="tableConfig"
            :page-info="pageInfo">
          <div slot="status" slot-scope="{ item }">
            <span v-if="item.status == -2">手工失效</span>
            <span v-if="item.status == -1">到期失效</span>
            <span v-if="item.status == 0">初始（未激活）</span>
            <span v-if="item.status == 1">可用（已激活）</span>
            <span v-if="item.status == 2">已使用</span>
          </div>
          <div slot="opera" slot-scope="{ item }">
            暂无
          </div>
        </table-merge>
      </div>
    </v-card>
  </div>
</template>

<script>
import TableMerge from "../../../../components/elTable/tableMerge";
import TableSearch from "../../../../components/elTable/tableSearch";
import GrouponApi from "../../../../api/sm/market/groupon/grouponApi"
import downloadUtil from "@/util/downloadUtil";
export default {
  name: "grouponDetailList",
  components: {
    TableMerge, TableSearch
  },
  props: {
    page: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    },
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      formInline: {
        handleNo: '',
        amount: ''
      },
      formItemList: [
        {
          label: '券编号', code: 'handleNo', type: 'text', placeholder: '请输入'
        },
        {
          label: '券面值', code: 'amount', type: 'text', placeholder: '请输入'
        }
      ],
      tableConfig: {
        isCheckBox: 0,
        isOpera: 1
      },
      tableData: [],
      tableField: [
        {columnCode: 'recordId',columnName: '赠券编号', isSlot: 0, width: 200},
        {columnCode: 'couponCode',columnName: '卖券编号', isSlot: 0, width: 200},
        {columnCode: 'amount',columnName: '面值金额', isSlot: 0, width: 150},
        {columnCode: 'status',columnName: '状态', isSlot: 1, width: 150}
      ],
      pageInfo: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      }
    }
  },
  created() {
  },
  mounted() {
    this.getDetailList()
  },
  methods: {
    back() {
      this.$emit('back', {formStatus: 'list'})
    },
    async exportData() {
      let res = await GrouponApi.exportDetailList(this.item.id)

      downloadUtil.downloadByBlob({res: res.data, fileName: "赠券明细.xlsx"});
    },
    getDetailList() {
      let that = this
      let params = {
        recordId: this.item.id,
        pageNo: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize
      }
      GrouponApi.getCouponInfo(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.tableData = res.data.rows
          that.pageInfo.total = res.data.total
        }
      })
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>